<template>
  <header class="app-header">
    <a :href="`/${$i18n.locale}`" class="app-header__logo">
      <slot name="logo" />
      <div class="app-header__logo-service">{{envs.serviceName}}</div>
      <div class="app-header__logo-root">
        {{$t('header.by')}}
        <a :href="`//${envs.root.href}/${$i18n.locale}`">{{envs.root.name}}</a>
      </div>
    </a>
    <div class="app-header__content" v-if="$slots.content || true">
      <slot name="content" />
    </div>
    <div class="app-header__user">
      <div class="app-header__user-locales">
        <slot name="locales">
          <Locales />
        </slot>
      </div>
      <slot name="settings" />
      <div class="app-header__user-session">
        <Session />
      </div>
    </div>
  </header>
</template>

<script>
  import Locales          from "./locales.vue";
  import Session          from "./session/session.vue";

  export default {
    name: "Header",
    data() {
      return {
        envs: {
          serviceName: envs.serviceName,
          root: envs.root,
        }
      };
    },
    components: {
      Locales,
      Session,
    },
  }
</script>
